import { render, staticRenderFns } from "./importEx.vue?vue&type=template&id=ef4a86f4&scoped=true"
import script from "./importEx.vue?vue&type=script&lang=js"
export * from "./importEx.vue?vue&type=script&lang=js"
import style0 from "./importEx.vue?vue&type=style&index=0&id=ef4a86f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef4a86f4",
  null
  
)

export default component.exports